/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import WeChatAccountChoice from 'components/shared/wechat-account-choice';

interface WeChatAccountChoiceContainerProps extends WithTranslation {}

const WeChatAccountChoiceContainer: React.FC<WeChatAccountChoiceContainerProps> = ({ t }) => {
  // Get the registration token from localStorage
  const registrationToken = localStorage.getItem('wechat_registration_token');

  if (!registrationToken) {
    // If no token, redirect back to login
    window.location.href = '/';
    return null;
  }

  return <WeChatAccountChoice registrationToken={registrationToken} />;
};

export default withTranslation()(WeChatAccountChoiceContainer);
